
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/api/modal-close",
      function () {
        return require("private-next-pages/joy-ui/api/modal-close.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/api/modal-close"])
      });
    }
  